import { createFileRoute } from "@tanstack/react-router";
import { AuthGuard } from "../components/Auth/AuthGuard";
import { MarketRecapPage } from "../components/market-recap/MarketRecapPage";

export const Route = createFileRoute("/market-recap")({
  component: () => (
    <AuthGuard>
      <MarketRecapPage />
    </AuthGuard>
  ),
});
